import { ApolloClient } from "@apollo/client";
import { ME } from "@components/Header/graphql";
import Cookies from "js-cookie";

import { CustomStorage, storage } from "./storage";

interface LoginReponse {
	token: string;
	user: {
		id: string;
		name: string;
		email: string;
	};
}

export const getToken = (storage: CustomStorage): string | null => {
	try {
		if (storage.getItem("user")) {
			return JSON.parse(storage.getItem("user")!).token;
		}
	} catch {
		return null;
	}
};

export const getUserId = (storage: CustomStorage): string | null => {
	try {
		if (storage.getItem("user")) {
			return JSON.parse(storage.getItem("user")!).userId;
		}
	} catch {
		return null;
	}
};

export const updateUserInfo = (
	data: LoginReponse,
	// eslint-disable-next-line @typescript-eslint/ban-types
	client: ApolloClient<object>,
	path = "/",
): void => {
	const local = {
		token: data.token,
		userEmail: data.user.email,
		userId: data.user.id,
		userName: data.user.name,
	};

	storage.setItem("user", JSON.stringify(local));
	Cookies.set("token", local.token, { path });

	if (typeof window !== "undefined") {
		import("amplitude-js").then((amplitude) => {
			amplitude?.setUserId(data.user.id);
		});
	}

	client.writeQuery({
		data: {
			me: data.user,
		},
		query: ME,
	});
};
